import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider,isLoggedIn,useApp } from './AppContext';
import installDomainFetch from './api/domainFetch';

// [도메인 헤더 2026-07-26] 두 CRM(씨네체인/영화거래소) 동시 로그인 시 세션쿠키가 덮여 섞이는 문제 해결.
//   앱 마운트 전에 전역 fetch를 래핑해, same-origin 요청마다 이 창의 도메인(sessionStorage user.domain)을
//   X-Domain 헤더로 실어 보낸다(백엔드가 요청 한정으로 도메인 결정). 반드시 render 전에 1회 설치.
installDomainFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecoilRoot>
    <BrowserRouter>
    <AppProvider>
      <App />
      </AppProvider>
    </BrowserRouter>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();